module.exports = __webpack_public_path__ + "img/09.8cb7f557.svg";